import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";

export interface ArtistData {
    id: string;
    name: string;
    imageUrl: string;
    username: string;
}

export const ArtistService = {

    fetchTrendingArtists: async (limit: number = 18): Promise<ArtistData[]> => {
        try {
            const trendingRef = doc(firestore, "trendingArtists", "HCWHd0QJl5piad2vDdvc");
            const trendingSnap = await getDoc(trendingRef);

            if (!trendingSnap.exists()) {
                console.warn("Trending list not found.");
                return [];
            }

            const data = trendingSnap.data();
            const allArtistIDs: string[] = data?.artistIDs || [];

            if (allArtistIDs.length === 0) return [];

            const selectedIds = allArtistIDs.slice(0, limit);

            const artistPromises = selectedIds.map(async (userId) => {
                try {
                    const userDocRef = doc(firestore, "users", userId);
                    const userSnap = await getDoc(userDocRef);

                    if (userSnap.exists()) {
                        const userData = userSnap.data();

                        const artistName = userData.artistName || userData.name || "Unknown";
                        const avatarUrl = userData.avatarUrl || userData.profileImage;
                        const userNameHandle = userData.userName || "";

                        if (artistName) {
                            return {
                                id: userId,
                                name: artistName,
                                imageUrl: avatarUrl || "https://via.placeholder.com/150",
                                username: userNameHandle,
                            } as ArtistData;
                        }
                    }
                } catch (err) {
                    console.error(`Error fetching user ${userId}`, err);
                }
                return null;
            });

            const artists = await Promise.all(artistPromises);

            return artists.filter((a): a is ArtistData => a !== null);

        } catch (error) {
            console.error("Error fetching trending artists:", error);
            return [];
        }
    },
};